var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.86111L8 10.7222M15 21.1389L8 16.2778M8 13.5C8 14.4209 7.63125 15.3041 6.97487 15.9552C6.3185 16.6064 5.42826 16.9722 4.5 16.9722C3.57174 16.9722 2.6815 16.6064 2.02513 15.9552C1.36875 15.3041 1 14.4209 1 13.5C1 12.5791 1.36875 11.6959 2.02513 11.0448C2.6815 10.3936 3.57174 10.0278 4.5 10.0278C5.42826 10.0278 6.3185 10.3936 6.97487 11.0448C7.63125 11.6959 8 12.5791 8 13.5ZM22 22.5278C22 23.4487 21.6313 24.3318 20.9749 24.983C20.3185 25.6342 19.4283 26 18.5 26C17.5717 26 16.6815 25.6342 16.0251 24.983C15.3687 24.3318 15 23.4487 15 22.5278C15 21.6069 15.3687 20.7237 16.0251 20.0725C16.6815 19.4214 17.5717 19.0556 18.5 19.0556C19.4283 19.0556 20.3185 19.4214 20.9749 20.0725C21.6313 20.7237 22 21.6069 22 22.5278ZM22 4.47222C22 5.39311 21.6313 6.27629 20.9749 6.92745C20.3185 7.57862 19.4283 7.94444 18.5 7.94444C17.5717 7.94444 16.6815 7.57862 16.0251 6.92745C15.3687 6.27629 15 5.39311 15 4.47222C15 3.55133 15.3687 2.66816 16.0251 2.01699C16.6815 1.36582 17.5717 1 18.5 1C19.4283 1 20.3185 1.36582 20.9749 2.01699C21.6313 2.66816 22 3.55133 22 4.47222Z",
    stroke: "#C3C3C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIco);
export default __webpack_public_path__ + "static/media/shareIco.d55a6e42719c83287f5ab6925ca3d451.svg";
export { ForwardRef as ReactComponent };